import { _x } from '@wordpress/i18n'
import { useAppSelector } from '../store/hooks'

export default function NoResults() {
  const contactUrl = useAppSelector((state) => state.config.contactUrl)

  return (
    <div
      style={{
        paddingLeft: '15%',
        paddingRight: '15%',
        minHeight: '200px'
      }}
      className="d-flex flex-column justify-content text-center py-4"
    >
      <h3 className="display-3">
        {_x('No ICF found', 'Location Finder List No Results Title', 'icf')}
      </h3>
      <div className="mt-1">
        <a href={contactUrl} className="btn btn-default">
          {_x(
            'Contact us',
            'Location Finder List No Results Contact Button',
            'icf'
          )}
        </a>
      </div>
    </div>
  )
}
